// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs-container":"Breadcrumbs-module__breadcrumbs-container___1WbUN","breadcrumb-item":"Breadcrumbs-module__breadcrumb-item___21FoN"};